import moment from "moment";
import { parseCookies, setCookie } from "nookies";
import { Timeout } from "./apiConfig";
import { postRefreshTokenManagement } from "./notifications";
const endpointOrigin =
  process.env.NEXT_PUBLIC_STATE === "development"
    ? `${process.env.NEXT_PUBLIC_HOST}/${process.env.NEXT_PUBLIC_API_URL}/managements/${process.env.NEXT_PUBLIC_API_VERSION}`
    : `/${process.env.NEXT_PUBLIC_API_URL}/managements/${process.env.NEXT_PUBLIC_API_VERSION}`;

export const getConfiguration = (urlOrigin?: string, accessToken?: string) => {
  return fetch(
    urlOrigin
      ? `${urlOrigin}${endpointOrigin}/configurations`
      : `${endpointOrigin}/configurations`,
    {
      method: "GET",
      headers: accessToken
        ? {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          }
        : {
            "Content-Type": "application/json",
          },
      signal: Timeout(5).signal,
    }
  )
    .then((response) => response.json())
    .then((result) => result)
    .catch((error: TypeError) => {
      return {
        code: 500,
        error,
      };
    });
};

export const putConfiguration = (
  inputBody: any,
  urlOrigin?: string,
  accessToken?: string
) => {
  const allCookie = parseCookies();
  const token = allCookie[process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as any];

  const url = urlOrigin
    ? `${urlOrigin}${endpointOrigin}/configurations`
    : `${endpointOrigin}/configurations`;

  return fetch(url, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken ? accessToken : token}`,
    },
    body: JSON.stringify(inputBody),
  })
    .then(async (response) => {
      return {
        code: response.status,
        result: await response.json(),
      };
    })
    .then(async (result) => {
      if (result.code === 401) {
        const rsRefreshToken = await postRefreshTokenManagement(
          allCookie[process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any]
        );

        if (rsRefreshToken.accessToken && rsRefreshToken.refreshToken) {
          setCookie(
            null,
            process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as any,
            rsRefreshToken.accessToken,
            {
              path: "/",
              expires: moment().add(7, "days").toDate(),
              sameSite: "strict",
            }
          );

          setCookie(
            null,
            process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any,
            rsRefreshToken.refreshToken,
            {
              path: "/",
              expires: moment().add(7, "days").toDate(),
              sameSite: "strict",
            }
          );

          return fetch(url, {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${rsRefreshToken.accessToken}`,
            },
            body: JSON.stringify(inputBody),
          })
            .then(async (response) => {
              return {
                code: response.status,
                result: await response.json(),
              };
            })
            .then((rs) => {
              return { ...rs, accessToken: rsRefreshToken.accessToken };
            })
            .catch((_error) => ({ code: 401 }));
        } else {
          return { code: 401 };
        }
      } else {
        return result;
      }
    })
    .catch((error: TypeError) => {
      return error;
    });
};
